export default {"src":"/_next/static/media/Company4.373a843c.svg","height":80,"width":267,"blurWidth":0,"blurHeight":0};